import { apiUrlV2 } from "../constants/apiUrl"
import createSearchParams from "../utilities/createSearchParams"
import useUserType from "../hooks/useUserType"

const initialState = {
  pendingTransfers: null,
  completedTransfers: null,
  processingTransfers: null,
  paymentTxns: [],
  transfer: null,
  txn: null,
  isFetchingCompletedTransfers: null,
  isFetchingPaymentTxns: null,
  isFetchingTxn: null,
  isFetchingTransfer: null,
  amDealerCompletedTransfers: [],
  amDealerCompletedTransfersFetching: false
}

const createTransferSlice = (set, get) => ({
  ...initialState,
  fetchTransfer: (transferId) => {
    set(() => ({ isFetchingTransfer: true }))
    fetch(
      `${apiUrlV2}/transfers/${transferId}`,
      { headers: get().requestHeaders }
    )
      .then(response => response.json())
      .then(data => set((state) => ({ transfer: data.data, isFetchingTransfer: false })))
  },
  fetchTxn: (txnId) => {
    const isDealer = get().user.type === 'DealerUser'
    set(() => ({ isFetchingTxn: true }))
    fetch(
      `${apiUrlV2}${isDealer ? '' : '/dealers/' + get().dealer.id}/txns/${txnId}`,
      { headers: get().requestHeaders }
    )
      .then(response => response.json())
      .then(data => set((state) => ({ txn: data.data, isFetchingTxn: false })))
  },
  fetchCompletedTransfers: (params) => {
    const isDealer = get().user.type === 'DealerUser'

    set(() => ({ isFetchingCompletedTransfers: true }))
    fetch(
      `${apiUrlV2}${isDealer ? '' : '/dealers/' + get().dealer.id}/transfers?filter[scope]=completed&${createSearchParams(params)}`,
      { headers: get().requestHeaders }
    )
      .then(response => response.json())
      .then(data => set((state) => ({ completedTransfers: data.data, isFetchingCompletedTransfers: false })))
  },
  fetchPendingTransfers: () => {
    const isDealer = get().user.type === 'DealerUser'

    fetch(
      `${apiUrlV2}${isDealer ? '' : '/dealers/' + get().dealer.id}/transfers?filter[scope]=pending`,
      { headers: get().requestHeaders }
    )
      .then(response => response.json())
      .then(data => set((state) => ({ pendingTransfers: data.data })))
  },
  fetchProcessingTransfers: () => {
    const isDealer = get().user.type === 'DealerUser'

    fetch(
      `${apiUrlV2}${isDealer ? '' : '/dealers/' + get().dealer.id}/transfers?filter[scope]=processing`,
      { headers: get().requestHeaders }
    )
      .then(response => response.json())
      .then(data => set((state) => ({ processingTransfers: data.data })))
  },
  fetchPaymentTxns: (params) => {
    const isDealer = get().user.type === 'DealerUser'

    set(() => ({ isFetchingPaymentTxns: true }))
    fetch(
      `${apiUrlV2}${isDealer ? '' : '/dealers/' + get().dealer.id}/txns/payment-txns?${createSearchParams(params)}`,
      { headers: get().requestHeaders }
    )
      .then(response => response.json())
      .then(data => set((state) => ({ paymentTxns: data.data, isFetchingPaymentTxns: false })))
  },
  createTransferChangeRequest: async (transferId, body) => {
    set(() => ({ isFetchingTransfer: true }))
    const response = await fetch(
      `${apiUrlV2}/transfers/${transferId}/transfer_change_requests`, {
      method: 'POST',
      headers: { 'Authorization': get().requestHeaders['Authorization'] },
      body: body
    })
    const data = await response.json()

    if (response.ok) {
      get().setSuccessMessage('Your transfer change request has been submitted successfully.')
      set((state) => ({ transfer: data.data, isFetchingTransfer: false }))
    } else {
      const firstErrorKey = data?.errors && Object.keys(data.errors)[0]
      const firstErrorMessage = firstErrorKey ? `${firstErrorKey.charAt(0).toUpperCase() + firstErrorKey.slice(1)} ${data.errors[firstErrorKey][0]}` : null
      const errorMessage = firstErrorMessage ?? 'There was an error submitting your transfer change request.'
      get().logError(errorMessage, data)
      set((state) => ({ isFetchingTransfer: false }))
    }
  },
  setTransfer: (transfer) => set({ transfer: transfer }),
  resetTransferSlice: () => set(initialState)
})

export default createTransferSlice